import {isValidUrl} from "../../utils/isValidUrl";

export function decorateImagesBox(data, typeName, timelineEntry) {
    let container = $(".timeline_entry." + typeName + "#" + timelineEntry.id);
    let imageContainer = container.find(".js-image-gallery");

// Append images

    $.each(data.images, function (key, image) {
        let imgSrc = "";

        if (image.filename && image.filename.trim() !== "") {
            if (isValidUrl(image.filename)) {
                // Full valid URL
                imgSrc = image.filename;
            } else {
                // Not a URL, treat as filename
                imgSrc = "/userdata/stammtisch/resize/" + image.filename;
            }
        } else {
            // Fallback image
            imgSrc = "/layout/frontend/stiegl/dist/images/event-blog-image.jpg";
        }

        imageContainer.append(
            '<div>' +
            '<img src="' + imgSrc + '" alt="" loading="lazy" />' +
            '</div>'
        );
    });

    container.find(".js-spinner").hide();

// Wait for all images to load
    let images = imageContainer.find('img');
    let total = images.length;
    let loaded = 0;

    if (total > 0) {
        images.on('load', function () {
            loaded++;
            if (loaded === total) {
                imageContainer.owlCarousel({
                    items: 1,
                    margin: 10,
                    loop: false,
                    nav: false,
                    dots: true,
                    autoHeight: true,
                });
            }
        }).each(function () {
            // Fix for cached images in some browsers
            if (this.complete) $(this).trigger('load');
        });
    }

}